import { TmdxAvatar, Tooltip } from '@ds';
import { ConditionalRender } from '@ui';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { AssignedUser } from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';

type Props = {
  surgeon?: AssignedUser | undefined;
};

export const TXCenterSurgeonInfo = ({ surgeon }: Props) => {
  const fullName = getFullName(surgeon?.user?.firstName, surgeon?.user?.lastName);
  return (
    <SectionRow label="TX Center Surgeon">
      <ConditionalRender show={!!surgeon} placeholder="-">
        <div className="flex gap-2 items-center">
          <TmdxAvatar
            size="lg"
            radius="md"
            name={fullName || undefined}
            type="user"
            src={surgeon?.user?.photoPath}
            fallbackInitials
          />
          <Tooltip
            className="text-m-r!"
            content={`${surgeon?.user?.firstName ?? ''} ${surgeon?.user?.lastName ?? ''}`}
            showArrow
          >
            <span className="truncate min-w-0">
              {surgeon?.user?.firstName} {surgeon?.user?.lastName}
            </span>
          </Tooltip>
        </div>
      </ConditionalRender>
    </SectionRow>
  );
};
